export const BORDER_RADIUS = "8px";

export const BOTTOM_SHEET_BORDER_RADIUS = "20px";
export const BOTTOM_SHEET_Z_INDEX = 1001;

export const TOP_NAV_Z_INDEX = 100;
export const TOAST_Z_INDEX = 10000000000;
export const IMAGE_PREFIX =
  "https://cdn-alabaster.wishlink.com/creator-master/";

export const BANK_ICONS = {
  AIRP: "airtel-bank.png",
  UTIB: "axis-bank.png",
  BARB: "bob-bank.png",
  BKID: "boi-bank.png",
  MAHB: "bom-bank.png",
  CNRB: "canara-bank.png",
  CBIN: "central-bank.png",
  FDRL: "federal-bank.png",
  HDFC: "hdfc.png",
  ICIC: "icici-bank.png",
  IDIB: "idb-bank.png",
  IBKL: "idb-bank.png",
  IDFB: "idfc-bank.png",
  IPOS: "india-post-bank.png",
  INDB: "indusland-bank.png",
  KKBK: "kotak.png",
  IOBA: "overseas-bank.png",
  PUNB: "pnb.png",
  SBIN: "sbi.png",
  UCBA: "uco-bank.png",
  UBIN: "union-bank.png",
  YESB: "yes-bank.png",
} as const;

// Default bank icon for unknown IFSC codes
export const DEFAULT_BANK_ICON = "bank-icon.png";

export const getAssetUrl = (assetUrl: string) => {
  return IMAGE_PREFIX + assetUrl;
};
